import { useMemo } from 'react';

import { keyOf, NameAndCreateDateFormatter } from '@Components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, duplicateAction, editAction, defaultColumnId, defaultActiveColumn } from '@Components/Grid/utils/column'

import DeleteEntryWithReferences from './DeleteEntryWithReferences';
import ManageFields from './ManageFields';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Description', info => <NameAndCreateDateFormatter info={info} />, { initialSize: 'max-w-[20vw]' }),
    defaultColumn('slug', 'Slug', undefined, { initialSize: 'max-w-[20vw]', enableTruncateTooltip: true }),
    defaultColumn('step'),
    defaultColumn('conversion_step', 'Conversion Step'),
    defaultColumn('anchor', 'Anchor', undefined, { defaultVisible: false }),
    column.accessor('submit_label', {
      header: 'Submit Button Label',
      defaultVisible: false,
    }),
    column.accessor('device_type', {
      header: 'Device Type',
      cell: listOrAll,
      defaultVisible: false,
      enableSorting: false,
    }),
    column.accessor('allowed_on', {
      header: 'Allowed on',
      cell: listOrAll,
      defaultVisible: false,
      enableSorting: false,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction, duplicateAction, manageAction),
  ], [])
}

function listOrAll(info) {
  const value = info.getValue()
  return value ? value.join(', ') : 'All'
}

function deleteAction(info) {
  return <DeleteEntryWithReferences key={keyOf(info, 'delete')} info={info} />
}

function manageAction(info) {
  return <ManageFields key={keyOf(info, 'manage')} info={info} />
}
